export default __webpack_public_path__ + "static/media/footer-decoration.caa747a7.svg";